import { AuthApi } from './permission-api-client';
import { initializePermissionApi } from './utils';

export const authApi = initializePermissionApi(AuthApi);
